<template>
  <v-card>
    <v-list v-if="categories.length">
      <v-list-group
        v-for="(category, categoryIndex) in categories"
        :key="category.name"
        :prepend-icon="'mdi-file-tree'"
        no-action
      >
        <template v-slot:activator>
          <v-row justify="space-between" align="center" no-gutters>
            <v-col cols="10">
              <v-list-item-title>{{ category.name }}</v-list-item-title>
            </v-col>
            <v-col cols="auto">
              <v-row>
                <v-btn
                  icon
                  @click.stop.prevent="addCategoryChild(category.id)"
                >
                  <v-icon small> mdi-plus </v-icon>
                </v-btn>
                <v-btn
                  icon
                  @click.stop.prevent="editCategory(category)"
                >
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn
                  icon
                  @click.stop.prevent ="removeCategory(category.id)"
                >
                  <v-icon color="red">mdi-trash-can-outline</v-icon>
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </template>
        <v-list-item>
          <v-btn
            link
            small
            outlined
            color="primary"
            @click="addCategoryChild(category.id)"
          >
            <v-icon class="mr-2" small> mdi-plus </v-icon>
            Создать подкатегорию
          </v-btn>
        </v-list-item>
        <v-list-item
          v-for="child in category.children || []"
          :key="child.name"
          :prepend-icon="'mdi-file-tree'"
          @click="editCategory(child)"
        >
          <v-row justify="space-between" align="center" no-gutters>
            <v-col cols="11">
              <v-list-item-title>{{ child.name }}</v-list-item-title>
            </v-col>
            <v-col cols="1">
              <v-row justify="start" no-gutters class="ml-1">
                <v-btn
                  icon
                  @click.stop.prevent="editCategory(child)"
                >
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn
                  icon
                  @click.stop.prevent="removeCategory(child.id)"
                >
                  <v-icon color="red">mdi-trash-can-outline</v-icon>
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-list-item>
        <v-divider v-if="categoryIndex < categories.length - 1"/>
      </v-list-group>
    </v-list>
    <v-subheader v-else>
      Список пуст
    </v-subheader>
  </v-card>
</template>

<script>

export default {
  name: 'TreeInfoCategories',
  props: {
    data: {
      type: Array,
      default: null
    },
    loading: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    categories () {
      if (this.data === null) return []
      const output = []
      // recursion can be added here
      this.data.forEach(item => {
        // find and add all children
        const children = this.data.filter(child => child.parentId === item.id)
        if (children.length) children.forEach(child => item.children.push(child))
        // category (parent)
        if (item.parentId === null) output.push(item)
      })
      return output
    }
  },
  methods: {
    addCategoryChild (id) {
      this.$emit('new-category-children', id)
    },
    removeCategory (id) {
      this.$emit('remove-category', id)
    },
    editCategory (item) {
      this.$emit('edit-category', item)
    }
  }
}
</script>
